import { useStaticQuery, graphql } from 'gatsby'

export const useDataQuery = () => {
  const content = useStaticQuery(graphql`
    query DataQuery {
      content: allFile(filter: { name: { eq: "content" } }) {
        nodes {
          childEnJson {
            backgroundColor
            titleColor
            title
            teaserImage
            teaserPhone
            teaserAddress
            subTitle
            dataImage
            guestsImage
            actionTitle
            actionCtaTitle
            actionImage
            actionContent
            actionMenuButton
            months
            teaserFirstDateName
            teaserLastDateName
            teaserWidgetUrl
            guestsName
            formButton
            thanksTitle
            aboutImage
            aboutTitle
            aboutParagraphs
            galleryAbout {
              img
            }
            aboutServicesTitle
            servicesCtaUrl
            galleryServices {
              img
              info
            }
            videoLink
            videoPosterIos
            mapImage
            mapLink
            contactTitle
            site
            siteIcon
            email
            emailIcon
            address
            addressIcon
            phoneNumbers
            phoneNumbersIcon
            contactSoz {
              img
              src
            }
            contactTgLink
            mapWayButton
            mapCenter {
              lat
              lng
            }
            markerPosition {
              lat
              lng
            }
            markerTitle
            copyright
          }
          childUkJson {
            backgroundColor
            titleColor
            title
            teaserImage
            teaserPhone
            teaserAddress
            subTitle
            dataImage
            guestsImage
            actionTitle
            actionCtaTitle
            actionImage
            actionContent
            actionMenuButton
            months
            teaserFirstDateName
            teaserLastDateName
            teaserWidgetUrl
            guestsName
            formButton
            thanksTitle
            aboutImage
            aboutTitle
            aboutParagraphs
            galleryAbout {
              img
            }
            aboutServicesTitle
            servicesCtaUrl
            galleryServices {
              img
              info
            }
            videoLink
            videoPosterIos
            contactTitle
            site
            siteIcon
            email
            emailIcon
            address
            addressIcon
            mapImage
            mapLink
            phoneNumbers
            phoneNumbersIcon
            contactSoz {
              img
              src
            }
            contactTgLink
            mapWayButton
            mapCenter {
              lat
              lng
            }
            markerPosition {
              lat
              lng
            }
            markerTitle
            copyright
          }
          sourceInstanceName
        }
      }

      example: allFile(filter: { name: { eq: "content.example" } }) {
        nodes {
          childEnJson {
            backgroundColor
            titleColor
            title
            teaserImage
            teaserPhone
            teaserAddress
            subTitle
            dataImage
            guestsImage
            actionTitle
            actionCtaTitle
            actionImage
            actionContent
            actionMenuButton
            months
            teaserFirstDateName
            teaserLastDateName
            teaserWidgetUrl
            guestsName
            formButton
            thanksTitle
            aboutImage
            aboutTitle
            aboutParagraphs
            galleryAbout {
              img
            }
            aboutServicesTitle
            servicesCtaUrl
            galleryServices {
              img
              info
            }
            videoLink
            videoPosterIos
            mapImage
            mapLink
            contactTitle
            site
            siteIcon
            email
            emailIcon
            address
            addressIcon
            phoneNumbers
            phoneNumbersIcon
            contactSoz {
              img
              src
            }
            contactTgLink
            mapWayButton
            mapCenter {
              lat
              lng
            }
            markerPosition {
              lat
              lng
            }
            markerTitle
            copyright
          }
          childUkJson {
            backgroundColor
            titleColor
            title
            teaserImage
            teaserPhone
            teaserAddress
            subTitle
            dataImage
            guestsImage
            actionTitle
            actionCtaTitle
            actionImage
            actionContent
            actionMenuButton
            months
            teaserFirstDateName
            teaserLastDateName
            teaserWidgetUrl
            guestsName
            formButton
            thanksTitle
            aboutImage
            aboutTitle
            aboutParagraphs
            galleryAbout {
              img
            }
            aboutServicesTitle
            servicesCtaUrl
            galleryServices {
              img
              info
            }
            videoLink
            videoPosterIos
            contactTitle
            site
            siteIcon
            email
            emailIcon
            address
            addressIcon
            mapImage
            mapLink
            phoneNumbers
            phoneNumbersIcon
            contactSoz {
              img
              src
            }
            contactTgLink
            mapWayButton
            mapCenter {
              lat
              lng
            }
            markerPosition {
              lat
              lng
            }
            markerTitle
            copyright
          }
          sourceInstanceName
        }
      }
    }
  `)

  if (content.content.nodes.length === 0) {
    return content.example.nodes
  }

  return content.content.nodes
}
